module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.activePanel) ? _c('div', {
    staticClass: "sideways-content-fold"
  }, [_c('div', {
    staticClass: "portlet light bordered"
  }, [_c('div', {
    staticClass: "portlet-title"
  }, [_c('div', {
    staticClass: "caption"
  }, [(_vm.process === 'step_1') ? [_vm._v("\n\t\t\t\t\t\tEdit Skill Testing Questions\n\t\t\t\t\t")] : _vm._e(), _vm._v(" "), (_vm.process === 'step_2') ? [_vm._v("\n\t\t\t\t\t\tCreate New Skill Testing Question\n\t\t\t\t\t")] : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "portlet-body"
  }, [(_vm.errorMessage.length) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "data-close": "alert"
    },
    on: {
      "click": function($event) {
        _vm.clearError()
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.errorMessage))])]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.process === 'step_1') ? _c('div', {
    key: "step_1"
  }, [_c('button', {
    staticClass: "btn blue btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.throttledCreate()
      }
    }
  }, [_vm._v("Create a New Skill Testing Question")]), _vm._v(" "), (_vm.questions.length) ? _c('div', {
    staticClass: "margin-top-20 row search-content-4"
  }, [_c('div', {
    staticClass: "search-table table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped table-condensed"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Q")]), _vm._v(" "), _c('th', [_vm._v("A")]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', _vm._l((_vm.questions), function(question) {
    return _c('tr', [_c('td', [_c('h4', [_vm._v(_vm._s(question.question))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(question.answer))]), _vm._v(" "), _c('td', [_c('dropdown', [_c('button', {
      staticClass: "btn btn-sm btn-outline dropdown-toggle btn-default",
      attrs: {
        "slot": "button",
        "type": "button",
        "data-toggle": "dropdown"
      },
      slot: "button"
    }, [_c('i', {
      staticClass: "fa fa-cogs"
    })]), _vm._v(" "), _c('ul', {
      staticClass: "dropdown-menu",
      attrs: {
        "slot": "dropdown-menu"
      },
      slot: "dropdown-menu"
    }, [_c('li', [_c('a', {
      on: {
        "click": function($event) {
          _vm.deleteQuestionConfirmation(question)
        }
      }
    }, [_vm._v("Delete Question")])])])])], 1)])
  }))])])]) : _vm._e(), _vm._v(" "), (!_vm.questions.length) ? _c('div', {
    staticClass: "center margin-top-20 font-grey-cascade"
  }, [_c('i', [_vm._v("No questions created yet.")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.process === 'step_2') ? _c('div', {
    key: "step_2"
  }, [_c('form', {
    attrs: {
      "role": "form",
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.createQuestion($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label margin-bottom-20"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.newQuestion.question),
      expression: "newQuestion.question",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control input-sm",
    class: {
      'edited': _vm.newQuestion.question.length
    },
    attrs: {
      "type": "text",
      "id": "new_question_question"
    },
    domProps: {
      "value": (_vm.newQuestion.question)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newQuestion, "question", $event.target.value.trim())
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "new_question_question"
    }
  }, [_vm._v("Question")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label margin-bottom-20"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.newQuestion.answer),
      expression: "newQuestion.answer",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control input-sm",
    class: {
      'edited': _vm.newQuestion.answer.length
    },
    attrs: {
      "type": "text",
      "id": "new_question_answer"
    },
    domProps: {
      "value": (_vm.newQuestion.answer)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newQuestion, "answer", $event.target.value.trim())
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "new_question_answer"
    }
  }, [_vm._v("Answer")])]), _vm._v(" "), _c('div', {
    staticClass: "form-actions noborder invite-user-actions margin-top-20"
  }, [_c('button', {
    staticClass: "btn btn-default exit-invitation-setup",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closePanel()
      }
    }
  }, [_vm._v(" Return To UNOgames Dashboard")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.reverseForm()
      }
    }
  }, [_vm._v("Back")]), _vm._v(" "), _c('button', {
    key: "edit-skill-testing-question-submit",
    staticClass: "btn blue",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Submit "), _c('i', {
    staticClass: "fa fa-arrow-circle-right"
  })])])])]) : _vm._e()])], 1)])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5770a3fe!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/UNOgames/EditSkillTestingQuestions.vue
// module id = 432
// module chunks = 1